import Vue from 'vue'
import VModal from 'vue-js-modal'

import BlogContent from './components/blog-content.vue';
import Gallery from './components/gallery.vue';
import PageHeader from './components/page-header.vue';
import PdpCarousel from './components/pdp-carousel.vue';

import "../sass/main.scss";

import UI from "./data/ui";

// Data
Vue.prototype.$ui = UI(Vue)

// Vue Components
Vue.component(PageHeader.name, PageHeader)

Vue.component(BlogContent.name, BlogContent)
Vue.component(Gallery.name, Gallery)
Vue.component(PdpCarousel.name, PdpCarousel)

// Vue Plugins
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

// Initialize header
new Vue({
	el: '.Header',
})

// Initialize blog content
if(document.getElementsByClassName("BlogContent").length){
	new Vue({
		el: '.BlogContent',
	})
}
